import React from "react";
import {useLocation} from "react-router-dom";

export function useQueryParams() {
  let {search} = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}
